<template>
    <v-flex>
      <v-flex v-if="loadAction.failed"
              class="admin-only-text">
        <div class="admin-only-text__wrapper" >
          <div class="admin-only-text__title">{{chapterWaiverConstants.ADMIN_ONLY_TITLE}}</div>
          <div class="admin-only-text__details">{{chapterWaiverConstants.ADMIN_ONLY_TEXT}}</div>
        </div>
      </v-flex>
      <v-flex  v-else-if="!loadAction.failed && checkedWaiverVisibility">
        <ChapterWaiverBanner></ChapterWaiverBanner>
        <v-container>
          <v-flex
              md10
              lg9
              mx-auto
              my-5
              class="waiver-block peer-review-panel">
            <v-card class="panelBlock">
              <v-flex>
                <v-flex tag="h2">{{chapterWaiverConstants.PROSPECTIVE_MEMBER_WAIVERS}}
                </v-flex>
                <v-flex
                    v-if="!isWaiverList"
                    data-qe-id="PrpPanel_Waivers_showAll_link"
                    class="view-all-waivers__all-waivers"><span class="ypo_blue_color" @click="ShowAllWaiver()">{{chapterWaiverConstants.VIEW_ALL_WAIVERS}}</span></v-flex>
              </v-flex>
              <div v-infinite-scroll="getListOfWaiversPanelView" :infinite-scroll-distance="2000">
                <v-flex
                    class="prospective-member"
                    v-for="(prospectData,i) in listOfWaivers"
                    :key="i">
                  <WaiverFormCommon
                      :prospect="prospectData"
                      :isPanelMember="true"
                      :sequence="i"
                      :leadId="leadId"
                      @showDenyDialogBox = "showDenyDialogBox"/>
                </v-flex>
                <v-flex
                    class="prospective-member__loading"
                    v-if="loadAction.pending"
                    justify-center
                    text-xs-center>
                  <v-progress-circular indeterminate color="grey"></v-progress-circular>
                </v-flex>
                <v-flex
                    class="prospective-member__loading"
                    v-else-if="loadAction.failed"
                    justify-center
                    text-xs-center>
                  {{chapterWaiverConstants.INSUFFICIENT_PERMISSIONS}}
                </v-flex>
                <v-flex
                    class="prospective-member__loading"
                    v-else-if="!loadAction.pending && listOfWaivers && !(listOfWaivers.length > 0)"
                    justify-center
                    text-xs-center>
                  {{chapterWaiverConstants.WAIVER_LIST_EMPTY}}
                </v-flex>
              </div>
            </v-card>
          </v-flex>
        </v-container>
        <v-flex>
          <v-dialog
              v-model="showDenyDialog"
              scrollable
              persistent
              content-class="small">
            <DenyVoteDialog
                v-if="showDenyDialog"
                :leadId="deniedLeadId"
                :close-dialog-box="hideDenyDialogBox"
                :sequence="leadSequence">
            </DenyVoteDialog>
          </v-dialog>
        </v-flex>
      </v-flex>
    </v-flex>
</template>

<script>
    import ChapterWaiverBanner from "./ChapterWaiverBanner";
    import WaiverFormCommon from "./WaiverFormCommon";
    import { chapterWaiverConstants } from "./ChapterWaiver.constants";
    import { mapGetters, mapActions, mapMutations, mapState } from "vuex";
    import { storeGetters } from "../../store/storeGetters.constant";
    import { storeAction } from "../../store/storeActions.constant";
    import { storeMutation } from "../../store/storeMutations.constant";
    import DenyVoteDialog from "../ChapterWaiver/DenyVoteDialog";
    import { headerConstant } from "../Header/header.constant";

    export default {
        name: "PeerReviewPanel",
        components: {
            ChapterWaiverBanner,
            WaiverFormCommon,
            DenyVoteDialog,
        },
        created() {
            if (this.$route.query.leadId) {
                this.leadId = this.$route.query.leadId;
            }
            this.resetChapterWaiverList();
            this.determineWaiversView();
            this.getWaiverQuestions();
            this.getWaiverTypes();
            this.getTitleTypes();
        },
        data: () => {
            return {
                chapterWaiverConstants,
                getListWaiverInProgress: false,
                showDenyDialog: false,
                deniedLeadId: null,
                leadSequence: null,
                headerConstant,
                leadId: headerConstant.EMPTY_GUID,
                checkedWaiverVisibility: false,
            };
        },
        methods: {
            ...mapMutations({
                setVisibleProspect: `chapterWaiver/${storeMutation.setVisibleProspect}`,
                resetChapterWaiverList: `chapterWaiver/${storeMutation.resetChapterWaiverList}`,
            }),
            ...mapActions({
                getListOfWaivers: `chapterWaiver/${storeAction.getListOfWaivers}`,
                getWaiverDetails: `chapterWaiver/${storeAction.getWaiverDetails}`,
                getWaiverQuestions: `chapterWaiver/${storeAction.getWaiverQuestions}`,
                getWaiverTypes: `chapterWaiver/${storeAction.getWaiverTypes}`,
                getTitleTypes: `chapterWaiver/${storeAction.getTitleTypes}`,
            }),
            determineWaiversView() {
              this.getListOfWaiversPanelView();
            },
            getListOfWaiversPanelView() {
                if (!this.disableWaiverListInfiniteScroll && !this.getListWaiverInProgress) {
                    this.getListWaiverInProgress = true;
                    const viewType = this.chapterWaiverConstants.PRPMEMBER;
                    const leadId = this.leadId ? this.leadId : this.headerConstant.EMPTY_GUID;
                    const req = {
                        viewType,
                        leadId,
                    };
                    this.getListOfWaivers(req)
                        .finally(() => {
                            this.getListWaiverInProgress = false;
                            this.checkedWaiverVisibility = true;
                        });
                }
            },
            isWaiverVisible(index) {
                return this.visibleProspect === index;
            },
            showDenyDialogBox(res) {
                this.deniedLeadId = res.leadid;
                this.leadSequence = res.sequence;
                this.leadId = res.leadid;
                this.showDenyDialog = res.showDenyDialog;
            },
            hideDenyDialogBox() {
                this.showDenyDialog = false;
            },
            ShowAllWaiver() {
                this.$router.push({
                    path: '/peerReviewPanel',
                });
            },
        },
        computed: {
            ...mapState("actionState", ["actions"]),
            ...mapGetters({
                listOfWaivers: `chapterWaiver/${storeGetters.listOfWaivers}`,
                visibleProspect: `chapterWaiver/${storeGetters.visibleProspect}`,
                disableWaiverListInfiniteScroll: `chapterWaiver/${storeGetters.disableWaiverListInfiniteScroll}`,
                waiverDetails: `chapterWaiver/${storeGetters.waiverDetails}`,
                waiverStatus: `chapterWaiver/${storeGetters.memberVoteStatus}`,
            }),
            loadAction() {
                return this.actions[storeAction.getListOfWaivers];
            },
            isWaiverList() {
                return this.leadId === this.headerConstant.EMPTY_GUID;
            },
        },
    };
</script>

<style lang="scss">
    @import '../../common/styles/_colors.scss';
    @import '../../common/styles/responsive.scss';

    .peer-review-panel {
        .prospective-member {
            &__list-item {
                border-bottom: 1px solid $ypo-tile-border;
                align-items: center;
                padding: 10px 15px;

                &__view {
                    font-weight: bold;

                    span {
                        display: block;
                        color: $ypo-gray-text;
                        font-family: Raleway, serif;
                    }

                    .waiver-date {
                        color: $ypo-gray-text;
                        font-family: Raleway;
                        font-size: 12px;
                    }

                    i {
                        color: $ypo-cta;
                        cursor: pointer;
                    }
                }

                .success-text {
                    color: $ypo-green;
                }

                .failure-text {
                    color: $ypo-red;
                }
            }
        }
    }

    .view-all-waivers {
        position: relative;

        &__all-waivers {
            padding: 14px 10px 0 10px;
            position: absolute;
            right: 10px;
            top: 0px;

            span {
                text-decoration: underline;
                font-weight: 600;
                cursor: pointer;
            }

            @include breakpoint(xs) {
                position: relative;
                text-align: center;
            }

        }
    }

    .admin-only-text {
      display: flex;
      justify-content: center;
      text-align: center;
      &__wrapper {
        margin-top: 10%;
        max-width: 350px;
      }
      &__title {
        color: $ypo-primary-blue;
        font-size: 18px;
      }
    }
</style>
